import ServiceExec from '@/common/utils/ServiceExec';
import { common } from '@/common/service/ApiList';
import { hasLoadedConstants } from '@/store/modules/constant/defaults';

const INITIALIZE_TIMEOUT = 5000;
const RETRY_DELAYS = [1500, 3000, 7000, 15000, 30000];

let initializePromise = null;
let retryTimer = null;
let retryCount = 0;

const clearRetry = () => {
  if (!retryTimer) return;
  window.clearTimeout(retryTimer);
  retryTimer = null;
};

const scheduleRetry = (dispatch) => {
  if (typeof window === 'undefined' || retryTimer) return;
  const delay = RETRY_DELAYS[Math.min(retryCount, RETRY_DELAYS.length - 1)];
  retryCount += 1;
  retryTimer = window.setTimeout(() => {
    retryTimer = null;
    dispatch('initialize', { force: true });
  }, delay);
};

const createResult = ({ ok = false, hasCache = false, status = ServiceExec.status.NETWORK_ERROR, errorMessage = '' }) => ({
  ok,
  hasCache,
  status,
  errorMessage,
  shouldShowConnectionModal: !ok && !hasCache
});

const actions = {
  async initialize({ commit, dispatch, getters }, payload = {}) {
    if (initializePromise && !payload.force) return initializePromise;

    initializePromise = (async () => {
      const hasCache = getters.hasConstantCache;

      try {
        commit('setInitializeState', {
          isLoading: true
        });
        const response = await ServiceExec.get(
          common.enumModel,
          {},
          {
            notLoading: true,
            timeout: INITIALIZE_TIMEOUT
          }
        );
        const status = response?.status ?? ServiceExec.status.NETWORK_ERROR;
        const data = response?.data;

        if (status !== ServiceExec.status.OK || !data || typeof data !== 'object' || !hasLoadedConstants(data)) {
          commit('setInitializeState', {
            isLoading: false,
            isInitialized: false,
            lastStatus: status,
            lastErrorMessage: response?.errorMessage ?? '',
            retryCount
          });
          scheduleRetry(dispatch);
          return createResult({
            hasCache,
            status,
            errorMessage: response?.errorMessage ?? ''
          });
        }

        commit('setConstants', data);
        commit('setInitializeState', {
          isLoading: false,
          isInitialized: true,
          lastStatus: status,
          lastErrorMessage: '',
          retryCount: 0
        });
        retryCount = 0;
        clearRetry();

        return createResult({
          ok: true,
          hasCache: hasLoadedConstants(getters.getConstant),
          status
        });
      } catch (error) {
        commit('setInitializeState', {
          isLoading: false,
          isInitialized: false,
          lastStatus: ServiceExec.status.NETWORK_ERROR,
          lastErrorMessage: error?.message ?? '',
          retryCount
        });
        scheduleRetry(dispatch);
        return createResult({
          hasCache,
          errorMessage: error?.message ?? ''
        });
      } finally {
        initializePromise = null;
      }
    })();

    return initializePromise;
  }
};
export default actions;
